import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { CommonService } from '../common.service';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { BrowserModule } from '@angular/platform-browser';
declare let swal:any;
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
declare var $: any;

@Component({
  selector: 'app-accessmanagement',
  templateUrl: './accessmanagement.component.html',
  styleUrls: ['./accessmanagement.component.css']
})
export class AccessmanagementComponent implements OnInit {
  returnUrl= "/dashboard/createaccessmanagement";
    editurl= "/dashboard/editaccessmanagement";
    viewurl= "/dashboard/viewaccessmanagement";
    samepageroute="/dashboard/accessmanagement";
    isLoading:boolean=false;
    loginresponse:any;
    userrole:any;
    farm_userrole:any;
    farm_user:any;
    getlistApi:any;
    putstatusApi:any;
    getuserListData:any;
    isDisabled:boolean=false;
    admindisabledelete:any;
    isDisableddirector:any;
  constructor(private router: Router,private commonService: CommonService) { }

  async ngOnInit() {
    this.isLoading = true;
    var table;
    this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
    this.userrole=this.loginresponse.read_status;
    this.farm_userrole=this.loginresponse.user_farm_id;
    this.admindisabledelete=this.loginresponse.user_role;
    if(this.userrole==1){
     //this.isDisabled = true;
      // $(".edit").removeAttr("id"); // Element(s) are now enabled.
    }
    if(this.admindisabledelete==='Admin'){
      this.isDisabled = true;
       // $(".edit").removeAttr("id"); // Element(s) are now enabled.
     }
     if(this.admindisabledelete==='Director'){
      this.isDisableddirector =this.admindisabledelete;
     }
   
    this.farm_user=this.farm_userrole;
    if(this.farm_userrole){
      this.getlistApi= "/user_management/?farm_user="+this.farm_user;
    }
    else{
      this.getlistApi="/user_management";
    }
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      (res) => {
   
         $(function(){
          table = $("#myTable").DataTable();
         })
          this.getuserListData = res.data;
          setTimeout((res)=>{ 
           this.isLoading =false;
     }, 500);
     $('#speciessearch').on( 'keyup', function () {
      var inputValue =(<HTMLInputElement>document.getElementById('speciessearch')).value;
     table.search( inputValue ).draw();
  });
         })   
  }

  async userstatuschange(e){
     var getval=e.target.id.split("_");
     console.log(getval)
     var primarykey=getval[0];
     var statusupdatekey=getval[1];
    var statusvalue=
    {  
      "status":statusupdatekey
    }
      this.putstatusApi="/user_management/status/"+primarykey;
    (await this.commonService.putApi(this.putstatusApi,statusvalue)).subscribe(
      (res) => {
         alert("Status updated successfully");
         })  
         let currentUrl = this.samepageroute;
         this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
             this.router.navigate([currentUrl]);
         });
  }
  
  viewaccessManagement(e){
    console.log(e.target.id);
    sessionStorage.setItem('userId',e.target.id);
    this.router.navigate([this.viewurl]);
    this.router.navigate([this.viewurl]);
  }

  exportspecies(){
    this.exportAsExcelFile(this.getuserListData, 'user');
  }
  public exportAsExcelFile(json: any[], excelFileName: string): void {
  
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    console.log('worksheet',worksheet);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }
  
  }


